import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import PosthogPlugin from './plugins/posthog'


Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(PortalVue)
Vue.use(VueMeta)

InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({ el, app, props }) {
    // pass the user object (not just twitch_id)
    const user = props.props.initialPage?.props?.auth?.user
    Vue.use(PosthogPlugin, { user })
    new Vue({
      metaInfo: {
        titleTemplate: title => (title ? `${title} -SpethBot WebApp` : 'SpethBot WebApp'),
      },
      render: h => h(app, props),
    }).$mount(el)
  },
})
